// Levare Icon Library — thin wrappers around lucide-react
// Usage: import { Icon } from './Icons'; <Icon name="activity" size={16} color="var(--primary)" />

import {
  Activity, AlertCircle, AlertTriangle, Apple, Award, BarChart2,
  Bell, BookOpen, Brain, Briefcase, Calendar, Camera, Check,
  ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Circle,
  Clipboard, Clock, Droplets, Dumbbell, Edit2, Eye, EyeOff,
  FileText, Flame, FlaskConical, Heart, HelpCircle, Home,
  Image, Info, Leaf, Lock, LogOut, Mail, Menu,
  Moon, MoreHorizontal, PieChart, Plus, RefreshCw, Save,
  Search, Settings, ShoppingCart, Star, Sun, Target, Trash2,
  TrendingUp, TrendingDown, Upload, User, Users, Utensils,
  Weight, X, Zap, Minus, ChevronLeftSquare, Scale,
  Droplet, Wind, Thermometer, Pill, Stethoscope, Shield,
  MessageCircle, Send, RotateCcw, Download, Copy, CheckCircle,
  XCircle, ArrowRight, ArrowLeft, ArrowUp, ArrowDown,
  List, LayoutGrid, SlidersHorizontal, Filter,
} from 'lucide-react';

const ICONS = {
  activity: Activity, alert: AlertCircle, warning: AlertTriangle,
  apple: Apple, award: Award, 'bar-chart': BarChart2,
  bell: Bell, book: BookOpen, brain: Brain, briefcase: Briefcase,
  calendar: Calendar, camera: Camera, check: Check,
  'chevron-down': ChevronDown, 'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight, 'chevron-up': ChevronUp,
  circle: Circle, clipboard: Clipboard, clock: Clock,
  droplets: Droplets, droplet: Droplet, dumbbell: Dumbbell,
  edit: Edit2, eye: Eye, 'eye-off': EyeOff,
  file: FileText, flame: Flame, flask: FlaskConical,
  heart: Heart, help: HelpCircle, home: Home,
  image: Image, info: Info, leaf: Leaf, lock: Lock,
  logout: LogOut, mail: Mail, menu: Menu, moon: Moon,
  more: MoreHorizontal, 'pie-chart': PieChart, plus: Plus,
  refresh: RefreshCw, save: Save, search: Search,
  settings: Settings, cart: ShoppingCart, star: Star,
  sun: Sun, target: Target, trash: Trash2,
  'trending-up': TrendingUp, 'trending-down': TrendingDown,
  upload: Upload, user: User, users: Users, utensils: Utensils,
  weight: Weight, x: X, zap: Zap, minus: Minus,
  scale: Scale, wind: Wind, thermometer: Thermometer,
  pill: Pill, stethoscope: Stethoscope, shield: Shield,
  message: MessageCircle, send: Send, rotate: RotateCcw,
  download: Download, copy: Copy, 'check-circle': CheckCircle,
  'x-circle': XCircle, 'arrow-right': ArrowRight,
  'arrow-left': ArrowLeft, 'arrow-up': ArrowUp,
  'arrow-down': ArrowDown, list: List, grid: LayoutGrid,
  sliders: SlidersHorizontal, filter: Filter,
};

export function Icon({ name, size = 16, color, style = {}, strokeWidth = 1.75 }) {
  const Component = ICONS[name];
  if (!Component) return null;
  return (
    <Component
      size={size}
      color={color || 'currentColor'}
      strokeWidth={strokeWidth}
      style={{ flexShrink: 0, ...style }}
    />
  );
}

export default Icon;
